/* global Modernizr */
import $ from 'jquery'
import { highlightBlock } from './highlight.js'
import Cookies from 'js-cookie'
import isUndefined from 'lodash-es/isUndefined'
import { MessageOverlay } from './message-overlay'
import { extractMessageFromAjaxFailure } from './ajax-error'

const debug = require('debug')('pm:application')
debug('loaded')

export const Postmark = (window.Postmark = {
  initialize: function () {
    debug('initialize')
    Postmark.forms()
    Postmark.codeFields()
    Postmark.announcement()
    Postmark.infinitePage()
    Postmark.tabViews()
    Postmark.dropdown()
    Postmark.downloadButtons()
    Postmark.usageGauge()

    // Detect IE 11 and edge browsers
    if (
      navigator.userAgent.match(/Trident.*rv:11\./) ||
      navigator.userAgent.match(/Edge/)
    ) {
      $('html').addClass('u-ms')
    }

    $(document).on('change', '.js-toggle', Postmark.toggle)

    $(document).on('click', '.js-mobile-nav-toggle', Postmark.toggleNav)

    $(document).on('click', '.js-refresh-window', function (event) {
      event.preventDefault()
      window.location.reload()
    })

    $('.js-print').on('click', function (e) {
      e.preventDefault()

      window.print()
    })

    $('.js-load-html').each(function () {
      const container = $(this)

      if (container.data('uri') !== undefined) {
        $.get(container.data('uri'), function (data) {
          container.removeClass('u-is-loading').html(data).trigger('loaded')
        })
      }
    })

    $.ajaxSetup({
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          'X-CSRF-Token',
          $('meta[name="csrf-token"]').attr('content')
        )
      },
    })

    // Close notifier box
    $(document).on('click', '.js-dismiss-notifier', Postmark.dismissNotifier)

    // Generic expanding container
    $(document).on('click', '.js-expand', function (event) {
      event.preventDefault()

      $(this).toggleClass('c-expand--open')

      // Toggle button label
      const toggleLabel = $(this).data('toggle-label')
      const defaultLabel = $(this).data('default-label')
      if (toggleLabel && defaultLabel) {
        const current = $(this).text()
        $(this).text(current === defaultLabel ? toggleLabel : defaultLabel)
      }

      const visible = $(this).hasClass('c-expand--open')
      $(this).attr('aria-expanded', visible)

      const target = $(this).data('target')
      $(target).slideToggle(250).attr('aria-hidden', !visible)
    })

    // Checkbox-controlled expanding containers.
    $('.js-checkbox-expand').on('change', function () {
      $(this).toggleClass('c-expand--open')

      const visible = $(this).hasClass('c-expand--open')
      $(this).attr('aria-expanded', visible)

      const target = $(this).data('target')
      $(target).slideToggle(250).attr('aria-hidden', !visible)
    })

    // Hide expanding containers.
    $('.js-expand').attr('aria-expanded', 'false')
    $('.js-expand-container').css('display', 'none').attr('aria-hidden', 'true')

    // Coupon Inputs
    $('.js-coupon-input').on('keyup', function () {
      const cleanValue = $(this).val().replace(/ /g, '_').toUpperCase()

      if (cleanValue !== $(this).val()) {
        $(this).val(cleanValue)
      }
    })
  },

  infinitePage: function () {
    if ($('body').hasClass('infinite-page')) {
      $('.main').css('min-height', $('body').height() - 70 + 'px')
    }
  },

  forms: function () {
    $('.c-form-submit input:submit').on('click', function (event) {
      // AJAX forms manage their own submit/loading state, so skip the
      // navigate-and-disable double-submit guard for them -- otherwise the
      // button is disabled expecting a page load that never comes.
      if ($(this).closest('form').is('.js-ajax-form')) {
        return
      }

      event.preventDefault()

      $(this).prop('disabled', true).parents('form').submit()
    })

    $('input.empty, textarea.empty').each(function () {
      const el = $(this)
      const emptyValue = el.attr('title')

      if (el.val() === '') {
        el.val(emptyValue)
      } else {
        el.removeClass('empty')
      }

      el.on('focus', function () {
        if (el.hasClass('empty')) {
          el.removeClass('empty')
        }

        if (el.val() === emptyValue) {
          el.val('')
        }
      })

      el.on('blur', function () {
        if (el.val() === '') {
          if (!el.hasClass('empty')) {
            el.addClass('empty')
          }
          el.val(emptyValue)
        }
      })

      $(el.get(0).form).on('submit', function () {
        if (el.val() === emptyValue) {
          el.val('')
        }
      })
    })

    // Detect onchange and enable submit
    $(document).on('change keyup', '.js-onchange-enable', function () {
      $(this).find('input[type=submit]').prop('disabled', false)
    })
  },

  codeFields: function () {
    $('input:text.code-field').each(function () {
      $(this).attr('size', $(this).val().length + 1)
    })
  },

  announcement: function () {
    $('.js-announcement-dismiss').on('click', function (event) {
      event.preventDefault()

      $.post($(this).attr('href'), function () {
        $('.announcement').slideUp()
      })
    })
  },

  tabViews: function () {
    $(document).on('click', '.js-tab-view', function (event) {
      event.preventDefault()

      // Update views
      $('[data-tab-view]').removeClass('active')
      $('[data-tab-view=' + $(this).data('view') + ']').addClass('active')

      // Update tabs
      $(this).parents('ul').find('li').removeClass('active')
      $(this).parent('li').addClass('active')

      // Trigger an event
      $.event.trigger({
        type: 'tab-changed',
        tab: $(this).data('view'),
        tabContainer: $(this).parent().parent().data('tabs'),
      })
    })
  },

  dropdown: function () {
    let activeItem

    $(document).on('click', '.js-dropdown-button', function (event) {
      event.preventDefault()

      const that = $(this),
        documentEvent = 'click.dropdownClickEvent',
        itemActiveClass = 'item-dropdown--active'

      function openDropdown() {
        activeItem = that

        const parent = that.parent('.item-dropdown'),
          list = that.next('.js-dropdown-list')

        // Show dropdown
        parent.addClass(itemActiveClass)
        list.fadeIn(100)

        // Bind document click for closing the dropdown
        $(document).on(documentEvent, function (event) {
          const target = event.target

          if (
            !$(target).is('.js-dropdown-button') &&
            !$(target).parents().is('.js-dropdown-button')
          ) {
            list.fadeOut(100)
            parent.removeClass(itemActiveClass)

            $(document).off(documentEvent)
            activeItem = undefined
          }
        })
      }

      // Check if there's an active item
      if (activeItem) {
        activeItem.next('.js-dropdown-list').fadeOut(200)
        activeItem.parent('.item-dropdown').removeClass(itemActiveClass)
        $(document).off(documentEvent)

        // Check if active item doesn't match current item
        if (!activeItem.is(that)) {
          openDropdown()
        } else {
          activeItem = undefined
        }
      } else {
        openDropdown()
      }
    })
  },

  toggle: function () {
    // $checkbox toggle
    const $checkbox = $(this)

    $.post($checkbox.data('toggle-uri'), $checkbox.serialize())
      .done(function () {
        // Show success message
        const state = $checkbox.prop('checked') ? 'enabled' : 'disabled'
        MessageOverlay.show(
          $checkbox.data('message-prefix') + ' has been ' + state + '.'
        )

        // Check for data-target-content and toggle it
        if ($checkbox.data('target-content')) {
          const $targetContent = $('#' + $checkbox.data('target-content'))

          $targetContent.fadeToggle(150, function () {
            // Check for secondary target container
            if ($checkbox.data('target-content-swap')) {
              $('#' + $checkbox.data('target-content-swap')).fadeToggle(150)
            }

            // Enable content checkboxes
            if ($checkbox.data('content-enable-checkboxes')) {
              $targetContent.checkboxProps(true)
            }
          })
        }
      })
      .fail(function (jqXHR) {
        // Switch back to previous state
        $checkbox.prop('checked', !$checkbox.is(':checked'))
        MessageOverlay.show(
          extractMessageFromAjaxFailure(
            jqXHR,
            'There was a problem saving your change. Please try again.'
          ),
          'error'
        )
      })
  },

  downloadButtons: function () {
    // If download attribute is not supported,
    // open file in new tab
    if (!Modernizr.adownload) {
      $('.js-download-button').attr('target', '_blank').removeAttr('download')
    }
  },

  highlightCode: function () {
    // Used for highlighting code snippets inside of popups
    $('pre code').each(function (i, block) {
      highlightBlock(block)
    })
  },

  dismissNotifier: function (event) {
    event.preventDefault()
    $(this).parents('.notifier').slideUp(250)

    // Set cookie
    const cookieOption = $(this).attr('data-dismiss-cookie')
    if (!isUndefined(cookieOption)) {
      Cookies.set(cookieOption, '1', {
        expires: parseInt($(this).attr('data-expires')),
        samesite: 'Lax',
      })
    }
  },

  usageGauge: function () {
    const $gauge = $('.js-usage-gauge')
    const usage =
      $gauge.data('percentage') > 100 ? 100 : $gauge.data('percentage')
    const percentage = usage / 100
    const degrees = 180 * percentage
    const pointerDegrees = degrees - 90

    $gauge.find('.gauge_fill').attr({
      style: 'transform: rotate(' + degrees + 'deg)',
    })

    $gauge.find('.gauge_pointer').attr({
      style: 'transform: rotate(' + pointerDegrees + 'deg)',
    })
  },

  toggleNav: function (e) {
    e.preventDefault()

    $('.js-mobile-nav').toggleClass('is-open')
    $(this).toggleClass('active')
  },
})

$(Postmark.initialize)
$(window).on('resize', Postmark.infinitePage)
